// Función para determinar la URL de la API basada en el hostname actual
function getApiUrl() {
    const hostname = window.location.hostname;

    // Desarrollo local
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return "http://127.0.0.1:5000";
    }

    // QA - dominio personalizado del frontend
    if (hostname === 'qa-palmtrade.navio.cl') {
        return "https://qa-palmtrade.navio.cl";
    }

    // QA - hostname específico de Azure
    if (hostname === 'qa-erp-app-backend-h2fmgnd9a5ekbydh.chilecentral-01.azurewebsites.net') {
        return "https://qa-erp-app-backend-h2fmgnd9a5ekbydh.chilecentral-01.azurewebsites.net";
    }

    // QA - cualquier hostname que contenga 'qa' y 'azurewebsites.net'
    if (hostname.includes('qa') && hostname.includes('azurewebsites.net')) {
        return `https://${hostname}`;
    }

    // Producción - cualquier otro dominio de azurewebsites.net
    if (hostname.includes('azurewebsites.net')) {
        return "https://erp-app-backend.azurewebsites.net";
    }

    // SPA en dominio propio (p. ej. palmtrade.navio.cl): backend desde build o Azure por defecto
    if (process.env.REACT_APP_API_URL_PROD) {
        return process.env.REACT_APP_API_URL_PROD;
    }
    if (hostname === 'palmtrade.navio.cl') {
        return "https://palmtrade.navio.cl";
    }

    // Fallback solo desarrollo
    return "http://127.0.0.1:5000";
}

export const urlApiProd = getApiUrl();
export const entorno = 'DEBUG'; // DEBUG PROD
export const version = 'v0.0.3';

/** Etiqueta para banda de entorno: DEBUG (local), QA, o null (producción — no mostrar). */
export function getEnvironmentBannerLabel() {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'ENTORNO DE DESARROLLO';
    }
    if (
        hostname.includes('qa-palmtrade') ||
        hostname === 'qa-erp-app-backend-h2fmgnd9a5ekbydh.chilecentral-01.azurewebsites.net' ||
        (hostname.includes('qa') && hostname.includes('azurewebsites.net'))
    ) {
        return 'ENTORNO DE PRUEBAS';
    }
    return null;
}



export function getCurrentDate(separator = '-') {

    let newDate = new Date()
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();

    return `${year}${separator}${month < 10 ? `0${month}` : `${month}`}${separator}${date}`
}

/**
 * Fecha/hora para UI Chile. Los DateTime naive del API (sin Z) se tratan como UTC
 * (Azure/Postgres) y se muestran en America/Santiago.
 */
export function formatDateTimeChile(iso) {
    if (iso == null || iso === '') return '—';
    const raw = String(iso).trim();
    if (!raw) return '—';
    const hasTz = /Z$/i.test(raw) || /[+-]\d{2}:?\d{2}$/.test(raw);
    const asIso = raw.includes('T') ? raw : raw.replace(' ', 'T');
    const normalized = hasTz ? asIso : `${asIso}Z`;
    const d = new Date(normalized);
    if (Number.isNaN(d.getTime())) return raw;
    return d.toLocaleString('es-CL', {
        timeZone: 'America/Santiago',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    });
}

export function formatDDMMYYYY(dateString) {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    return `${day}-${month}-${year}`;
}

export function formatYYYYMMDD(dateString) {
    let [day1, month1, year1] = dateString.split('-')
    const dateObj = new Date(+year1, +month1 - 1, +day1)
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    return `${year1}-${month1}-${day1}`;
}

export function formatDateYYYYMMDD(dateString) {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export function eliminarDiacriticosEs(texto) {
    return texto
        .normalize('NFD')
        .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1")
        .normalize();
}

export function formatCurrency(currencyString) {
    let firstHalf = currencyString;
    return parseFloat(`${firstHalf}`).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', 'minimumFractionDigits': 2, 'maximumFractionDigits': 2 });
}

export function print(texto) {
    if (entorno === 'DEBUG') {
        console.log(texto);
    }
}

export const correoUsuario = async (id) => {
    var resultado = "No encontrado"
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/get_usuario/${id}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching datos usuario');
        const data = await response.json();
        print(data);
        resultado = data.correo;
    } catch (error) {
        print(`'Error en fetchData:', ${error.message}`);
        print(`historias no cargadas: ${error.message} { toastId: 'error-principal' }`);
    } finally {
        return resultado;
    }
}

export const capitalizeFirstLetter = (val) => {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

export const handleEliminar = async (id, servicio) => {
    const token = localStorage.getItem('token');
    try {
        const response = await fetch(`${urlApiProd}/${servicio}/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) throw new Error('Error eliminando');
        return 'Eliminado exitosamente';
    } catch (error) {
        console.error('Error:', error);
        return 'No se pudo eliminar';
    }
};

export const handleAgregar = async (servicio, dataEnviar) => {
    const token = localStorage.getItem('token');
    try {
        const response = await fetch(`${urlApiProd}/${servicio}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: dataEnviar,
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Error al agregar');
        } else {
            return "Agregado correctamente";
        }
    }
    catch (error) {
        print(`Error: ${error}`);
        return "Error al agregar";
    }

};

export function subtractDaysFromDate(currentDate, daysToSubtract) {
    daysToSubtract = daysToSubtract || 0

    // Instantiate a new object based on the current Date
    const pastDate = new Date(currentDate)

    // Subtract  the number of days
    pastDate.setDate(pastDate.getDate() - daysToSubtract)

    return pastDate
}

export const Checkbox = ({ isChecked, label, checkHandler, index }) => {
    return (
        <div>
            <input
                type="checkbox"
                id={`checkbox-${index}`}
                checked={isChecked}
                onChange={checkHandler}
            />
            <label htmlFor={`checkbox-${index}`}>{label}</label>
        </div>
    )
}
